import { render, staticRenderFns } from "./AddressAdd.vue?vue&type=template&id=6334dab5&"
import script from "./AddressAdd.vue?vue&type=script&lang=js&"
export * from "./AddressAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports